import { AfterViewChecked, Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import * as marked from 'marked';
import { AppComponent } from '../../../../../app.component';

@Component({
  selector: 'anon-markdown',
  templateUrl: './markdown.component.html',
  styleUrls: ['./markdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MarkdownComponent implements AfterViewChecked, OnChanges {
  @Input() markdown: string | undefined | null = '';
  convertedMarkdown: any;
  md: any;

  constructor() {}

  ngOnChanges() {
    this.md = marked;
    this.md.setOptions({})
    if (this.markdown) this.convertedMarkdown = this.md.parse(this.markdown);
  }

  ngAfterViewChecked() {
    if (AppComponent.isBrowser) {
      const hljs = require('highlight.js');
      hljs.configure({ignoreUnescapedHTML: true});
      hljs.highlightAll();
    }
  }
}
